import { render, staticRenderFns } from "./feeling.vue?vue&type=template&id=949f84dc&scoped=true"
import script from "./feeling.vue?vue&type=script&lang=js"
export * from "./feeling.vue?vue&type=script&lang=js"
import style0 from "./feeling.vue?vue&type=style&index=0&id=949f84dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949f84dc",
  null
  
)

export default component.exports